import TemplateView from '../../TemplateView'
import messageResource from '../../messageResource'
import {WorkflowStatusType} from '../constants'

export class WorkflowStatusTypeNode extends TemplateView {
    constructor(type) {
        super(null)

        this.type = type
    }

    templateHtml() {
        return '<div class="workflowStatusTypeNode"><%-text%></div>'
    }

    templateModel() {
        return {
            text: messageResource.getMessage(
                this.type === WorkflowStatusType.OPEN
                    ? 'workflow_list.open_tasks'
                    : 'workflow_list.completed_tasks'
            )
        }
    }
}

export default WorkflowStatusTypeNode



// WEBPACK FOOTER //
// ./web/js/workflowStatus/components/WorkflowStatusTypeNode.js